import React from 'react'
import { Link } from 'react-router-dom'

function Meds() {
  return (
    <div>
      <Link to="/meds/terms">
        <div>Terms and Conditions</div>
      </Link>
      <Link to="/meds/policy">
        <div>Privacy Policy</div>
      </Link>
    </div>
  )
}

export default Meds
